module.exports = __webpack_public_path__ + "static/media/002-emoji-1.a8b7f5f6.svg";